module.exports = __webpack_public_path__ + "static/media/avatar.b23d5960.jpg";